<template>
  <div>
    <loading v-if="load"/>
    <div v-else-if="dados">
      <div class="close">
        <button class="btn btn-sm" @click="close()"><i class="fa fa-times"></i></button>
      </div>
      <div class="text-center border-bottom" style="margin-bottom: 18px; padding-bottom: 12px">
        <div class="user"><i class="fa fa-user"></i></div>
        <h6 class="mt-2 mb-0">{{dados.nome_user || 'Sem nome'}}</h6>
        <div class="small">Cliente desde de {{dados.created_at}}</div>
      </div>
      <div class="row no-gutters" v-if="dados.id_cliente">
        <div class="col-md-6 mb-2 pr-md-1">
          <div class="card-dados">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bookmarks-filled" width="28" height="28" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M12 6a4 4 0 0 1 4 4v11a1 1 0 0 1-1.514.857L10 19.166l-4.486 2.691a1 1 0 0 1-1.508-.743L4 21V10a4 4 0 0 1 4-4z" fill="currentColor" stroke="none"/><path d="M16 2a4 4 0 0 1 4 4v11a1 1 0 0 1-2 0V6a2 2 0 0 0-2-2h-5a1 1 0 0 1 0-2z" fill="currentColor" stroke="none"/></svg>
            <div class="ml-2">
              <div class="text-dark">{{dados.qtd_pedido || '0'}}</div>
              <div class="small">Pedidos feitos</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-2 pl-md-1">
          <div class="card-dados">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-basket-filled" width="28" height="28" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="m12.684 3.27.084.09 4.7 5.64H21a1 1 0 0 1 .991 1.131l-.02.112-1.984 7.918c-.258 1.578-1.41 2.781-2.817 2.838L17 21l-10.148-.002c-1.37-.053-2.484-1.157-2.787-2.57l-.035-.185-2-8a1 1 0 0 1 .857-1.237L3 9h3.53l4.702-5.64a1 1 0 0 1 1.452-.09M12 12a3 3 0 0 0-2.98 2.65l-.015.174L9 15l.005.176A3 3 0 1 0 12 12m0-6.438L9.135 9h5.73z" fill="currentColor" stroke="none"/></svg>
            <div class="ml-2">
              <div class="text-dark">{{dados.ultimo_pedido || 'Sem dados'}}</div>
              <div class="small">Último Pedido</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-2 pr-md-1">
          <div class="card-dados">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-coin-filled" width="28" height="28" viewBox="0 0 24 24" stroke-width="1.5" stroke="#858796" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M17 3.34A10 10 0 1 1 2 12l.005-.324A10 10 0 0 1 17 3.34M12 6a1 1 0 0 0-1 1 3 3 0 1 0 0 6v2a1.02 1.02 0 0 1-.866-.398l-.068-.101a1 1 0 0 0-1.732.998 3 3 0 0 0 2.505 1.5H11a1 1 0 0 0 .883.994L12 18a1 1 0 0 0 1-1l.176-.005A3 3 0 0 0 13 11V9c.358-.012.671.14.866.398l.068.101a1 1 0 0 0 1.732-.998A3 3 0 0 0 13.161 7H13a1 1 0 0 0-1-1m1 7a1 1 0 0 1 0 2zm-2-4v2a1 1 0 0 1 0-2" fill="currentColor" stroke="none"/></svg>
            <div class="ml-2">
              <div class="text-dark" v-if="dados.ticket_medio">{{dados.ticket_medio | valor}}</div>
              <div class="text-dark" v-else>Sem dados</div>
              <div class="small">Ticket médio</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-2 pl-md-1">
          <div class="card-dados">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-star-filled" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#858796" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="m8.243 7.34-6.38.925-.113.023a1 1 0 0 0-.44 1.684l4.622 4.499-1.09 6.355-.013.11a1 1 0 0 0 1.464.944l5.706-3 5.693 3 .1.046a1 1 0 0 0 1.352-1.1l-1.091-6.355 4.624-4.5.078-.085a1 1 0 0 0-.633-1.62l-6.38-.926-2.852-5.78a1 1 0 0 0-1.794 0z" fill="currentColor" stroke="none"/></svg>
            <div class="ml-2">
              <div class="text-dark">{{dados.avaliacao || 'Sem dados'}}</div>
              <div class="small">Avaliação média</div>
            </div>
          </div>
        </div>
      </div>
      <div class="border py-3 px-2 mb-3" style="border-radius: 8px">
        <div class="text-center">
          <p class="mb-2">Clique abaixo para acessar o WhatsApp</p>
          <button class="btn btn-primary px-4" @click="acessarWpp(dados)"><i class="fab fa-whatsapp mr-1"></i> Acessar</button>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center my-2">
        <h6 class="font-weight-bold mb-0">Informações pessoais</h6>
        <button class="btn btn-sm" @click="editar(false)" v-if="!editarNome"><i class="fa fa-pencil-alt"></i></button>
        <div v-else>
          <button class="btn btn-sm mr-2" @click="editar(true)"><i class="fa fa-times"></i></button>
          <button class="btn btn-sm btn-primary" @click="editar(true, true)"><i class="fa fa-check mr-1"></i> Salvar</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mb-2">
          <div class="small">Nome</div>
          <div class="text-dark mr-1" v-if="!editarNome">{{dados.nome_user || 'Sem nome'}}</div>
          <input type="text" class="form-control mr-2" placeholder="Nome do contato" maxlength="45" v-model="nome_user" v-else/>
        </div>
        <div class="col-md-6 mb-2">
          <div class="small">Telefone</div>
          <div class="d-flex align-items-center">
            <div class="text-dark mr-1">{{dados.telefone | phone}}</div>
            <button class="btn text-primary p-0" @click="acessarWpp(dados)"><i class="fab fa-whatsapp"></i></button>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="small">Status</div>
          <div class="text-dark mr-1">{{dados.status | status}}</div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="small">Última interação</div>
          <div class="text-dark mr-1">{{dados.ultima_msg}}</div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="small">Observações</div>
          <div class="text-dark mr-1">Sem observações</div>
        </div>
      </div>
      <div class="form-group d-none">
        <label class="mb-0">Observações</label>
        <textarea class="form-control" placeholder="Campo livre para informações do cliente"></textarea>
      </div>
      <div class="mt-3">
        <h6 class="font-weight-bold">Preferência de notificações</h6>
        <a class="text-dark text-nowrap text-decoration-none d-flex align-items-center" href="javascript:" @click="toggleContatoDisparo()">
          <img class="switch" src="../../assets/icons/switch-on.svg" v-if="dados.disparos === '1'" alt="Ativado"/>
          <img class="switch" src="../../assets/icons/switch-off.svg" v-else alt="Desativado"/>
          <span class="ml-2">{{ dados.disparos === '1' ? 'Deseja receber disparos no WhatsApp' : 'Não deseja receber disparos no WhatsApp' }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ModalMenu from "../commons/ModalMenu";
import Loading from "../commons/Loading";

export default {
  name: 'ClienteFormulario',
  components: {Loading, ModalMenu},
  props: ['token'],
  data() {
    return {
      load: false,
      menus: [{ nome: 'Dados', active: true }, { nome: 'Pedidos', active: true }],
      menu: 1,
      dados: null,
      editarNome: false,
      nome_user: ""
    }
  },

  methods: {
    selContato(id) {
      if (this.load) {
        return;
      }

      this.clear();
      this.load = true;
      this.$http.get('chatbot/contato/' + this.token + '?full=true&id=' + id).then(response => {
        this.load = false;

        if (response.data) {
          this.dados = response.data || {};
          this.menus[1].active = !!this.dados.id_cliente;
        }

      }, res => {
        this.load = false;
        this.$swal(res.data.msg || 'Erro temporário');
      });
    },

    editar(fechar, salvar) {
      if (salvar) {
        this.dados.nome_user = this.nome_user;
        const dados = { nome_user: this.nome_user, status: this.dados.status, id_chatbot_user: this.dados.id_chatbot_user }

        this.$http.post('chatbot/contato/status/' + this.token, dados).then(() => {
          this.$emit('editarContato', dados.id_chatbot_user, dados.nome_user);

        }, res => {
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
      }

      this.editarNome = !fechar;
      this.nome_user = !fechar ? this.dados.nome_user : '';
    },

    editarStatus(id_chatbot_user, status) {
      if (this.dados && this.dados.id_chatbot_user === id_chatbot_user) {
        this.dados.status = status;
      }
    },

    selCliente(id) {
      this.clear();
      this.load = true;
      this.$http.get('clientes/' + id + '/' + this.token).then(response => {
        if (response.data) {
          this.dados = response.data;
          this.menus[1].active = true;
        }

        this.load = false;

      }, res => {
        this.load = false;
        this.$swal(res.data.msg || 'Erro temporário');
      });
    },

    toggleContatoDisparo() {
      this.dados.disparos = this.dados.disparos === '1' ? '2' : '1';
      const dados = { disparos: this.dados.disparos, id_chatbot_user: this.dados.id_chatbot_user, status: this.dados.status }
      this.$http.post('chatbot/contato/status/' + this.token, dados).then(() => {}, res => {
        this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
      });
    },

    acessarWpp(dados) {
      if (this.isElectron && !this.session) {
        this.$swal("Não é possível acessar este Chat por que o Bot ainda está sendo iniciado.");
        return;
      }

      if (this.session) {
        window.control.acessarChat({ to: dados.wid || dados.id_user, wpp: this.session.wpp });
        this.$emit('goHome');

      } else {
        window.open('https://wa.me/' + this.$helpers.normalizarTelefone(dados.telefone));
      }
    },

    close() {
      this.$emit('close');
      this.dados = null;
    },

    clear() {
      this.nome_user = '';
      this.editarNome = false;
      this.dados = true;
    }
  },

  computed: {
    session() {
      return this.$store.state.session
    }
  }
}
</script>

<style scoped>
.close {
  position: absolute;
  top: 12px;
  right: 12px;
}
.user {
  background-color: #858796;
  color: #FFFFFF;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.card-dados {
  padding: 6px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  display: flex;
  align-items: center;
}
</style>
